import { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import toast from 'react-hot-toast'
import { uploadFile } from 'services/upload-file'

import { FileUpload } from './icons/FileUpload'

type Props = {
  triggersUploadEvent: boolean
  clearUploadEvent: boolean
  setTriggersUploadEvent: (value: boolean) => void
}

export const Dropzone = ({
  triggersUploadEvent,
  setTriggersUploadEvent,
  clearUploadEvent,
}: Props) => {
  const [file, setFile] = useState<File | null>(null)

  const onDrop = useCallback((acceptedFiles: any) => {
    if (acceptedFiles.length > 1) {
      toast.error('Somente é aceito um arquivo')
      return
    }

    const file = acceptedFiles[0] as File

    const MAX_FILE_SIZE = 10 * 1024 * 1024

    if (file.size > MAX_FILE_SIZE) {
      toast.error('O arquivo deve ter no máximo 10MB')
      return
    }

    if (file.type !== 'image/png') {
      toast.error('Somente são aceitos arquivos PNG')
      return
    }

    setFile(file)
  }, [])
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({ onDrop })

  const files = acceptedFiles.map((fileObj: any) => {
    if (fileObj.type !== 'image/png') {
      return
    }

    return (
      <>
        {file && (
          <li key={fileObj.path} id="file-item" className="list-item">
            <img
              src={URL.createObjectURL(file)}
              alt="Preview do arquivo"
              className="w-20 h-20"
            />
          </li>
        )}
      </>
    )
  })

  useEffect(() => {
    if (file) {
      setTriggersUploadEvent(true)
    }
  }, [file])

  useEffect(() => {
    if (!file) {
      return
    }

    if (!triggersUploadEvent) {
      return
    }

    const upload = async () => {
      try {
        await uploadFile(file)
      } catch (err) {
        toast.error('Erro ao fazer upload')
      } finally {
        setFile(null)
        setTriggersUploadEvent(false)
      }
    }

    upload()
  }, [triggersUploadEvent])

  useEffect(() => {
    if (clearUploadEvent) {
      setFile(null)
    }
  }, [clearUploadEvent])

  return (
    <section className="max-w-xl hover:cursor-pointer">
      <div
        {...getRootProps({
          className: 'border border-dashed border-gray-500 relative h-36',
        })}
      >
        <input {...getInputProps()} />
        <p className="flex flex-col w-full h-full items-center justify-center ">
          <FileUpload className="w-9 h-9 mb-1" color={'#4F46E5'} />
          <span className="text-[#4F46E5] text-md">Upload da imagem</span>
          <span className="text-gray-500 text-sm">PNG (Limite de 10 Mb)</span>
        </p>
      </div>
      <aside className={`mt-4 `}>
        <ul>{files}</ul>
      </aside>
    </section>
  )
}
